import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  // Structured business errors (dict with a `code` field), e.g. BIN_CAPACITY_EXCEEDED
  if (detail && typeof detail === "object" && typeof detail.code === "string") {
    if (detail.code === "BIN_CAPACITY_EXCEEDED") {
      return `Bin ${detail.bin_number} would overflow: ${detail.current_tons}t + ${detail.requested_tons}t = ${(detail.current_tons + detail.requested_tons).toFixed(1)}t > ${detail.capacity_tons}t (over by ${detail.over_by}t).`;
    }
    return detail.code;
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
